import React from 'react';

import GlobalLayout from 'Layouts/Global.layout';

import { Container, Text, Button, Icon } from 'UILib';
import 'Components/KYC/kyc.style.scss';
import { APP_ROUTES } from 'Constants/GlobalConstants/Global.constants';

const Success = (props) => {
  return (
    <Container type="page" bgColor="grey-0">
      <GlobalLayout>
        <div className="kyc-page-wrapper">
          <div className="kyc-success-wrapper">
            <div className="section-wrapper">
              <div className="step-wrapper">
                <Icon
                  base="regular"
                  icon={{
                    name: 'check-circle',
                    color: 'green-3'
                  }}
                  className="results-icon"
                />
              </div>
              <Text
                content="kyc.success.header"
                translation
                className="header"
              />
              <Text
                content="kyc.success.content"
                translation
                className="content"
              />
              <div className="action-zone">
                <Button
                  content="kyc.success.action.dashboard"
                  translation
                  borderColor="orange-3"
                  bgColor="white"
                  color="orange-3"
                  className="back"
                  onClick={() => {
                    props.history.push(APP_ROUTES.DASHBOARD);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </GlobalLayout>
    </Container>
  );
};

export default Success;
